export default { sha: 'a94e5443e64965e146b8174367bc88d2de45d58d', buildNumber: 'undefined' }
